/*
 * (6) O gancho da "Nova mensagem": `openNewMessage()` abre o modal (chunk
 * próprio). A barra lateral do tema o recebe pelo `sidebarHooks.newMessage`
 * (o "+" das "Mensagens diretas"); qualquer outro botão pode chamá-lo.
 */
import app from 'flarum/forum/app';
import { feature } from './flags';

/** A "Nova mensagem" está disponível para o leitor. */
export function canStartNewMessage() {
  return feature('new_message') && !!app.session.user && !!app.forum.attribute('canStartChatDirect');
}
export function openNewMessage() {
  if (!canStartNewMessage()) return;
  app.modal.show(() => import(/* webpackChunkName: 'forum/thirdparty/ramonChat/features/NewMessageModal', webpackMode: 'lazy-once' */ './NewMessageModal'));
}
flarum.reg.add('ramon-canela', 'forum/thirdparty/ramonChat/features/newMessage', { canStartNewMessage: canStartNewMessage,openNewMessage: openNewMessage, });flarum.reg.addChunkModule('forum/thirdparty/ramonChat/features/NewMessageModal', './src/forum/thirdparty/ramonChat/features/NewMessageModal.tsx', 'ramon-canela', 'forum/thirdparty/ramonChat/features/NewMessageModal');